import Inactivity from './Inactivity'

export default Inactivity
